import React, { useState } from 'react'
import { toast } from 'react-toastify';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
const Iata = () => {
    const [rows, setRows] = useState([
        {
            account_no: '',
            // airline: '',

        },
    ]);
    // Function to add a new row
    const CurrOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const addRow = async () => {
        const currentRow = rows[rows.length - 1];

        // Check if the current row exists and if all its fields are filled
        if (currentRow && Object.values(currentRow).every(field => field !== '')) {
            // If all fields are filled, add a new row with empty fields
            setRows([...rows, {
                account_no: '',
                // airline: '',

            }]);
        } else {
            // Show an error message if any field is empty
            toast.error('Please fill all fields before adding a new row.');
        }
    };

    // Function to remove a row
    const removeRow = (index) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((_, i) => i !== index);
            setRows(updatedRows);
            // formik.setFieldValue('rows', updatedRows);
        } else {
            alert('At least one row must remain.');
        }
    };

    // Handle input change in each row
    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...rows];
        updatedRows[index][name] = value;
        setRows(updatedRows);
        // formik.setFieldValue(`rows[${index}].${name}`, value);
    };
    return (
        <>
            <div className="table-responsive ">
                {/* <Table className="table datanew dataTable no-footer" pagination={false}
            dataSource={dataSource} columns={columns} /> */}
                <table className="table table-responsive border custom-table-th">
                    <thead>
                        <tr>

                            <th scope="col" className='bg-none w-min-120'>Account No</th>
                            <th scope="col" className='bg-none w-min-120'>Airline</th>
                            <th scope="col" className='bg-none'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>

                                {/* Add input fields for each column */}
                                <td><input type="text" className="form-control form-control-sm" name="account_no" placeholder="Enter Organization Branch" value={row.account_no} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td> <Select

                                    className='custom-selector'
                                    options={CurrOpt}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                /></td>
                                <td>
                                    <div className="d-flex">
                                        <div className="add-icon cursor-pointer" onClick={addRow}>
                                            <AddIcon />
                                        </div>
                                        {index > 0 && (
                                            <div className="remove-icon cursor-pointer" onClick={() => removeRow(index)} style={{ marginLeft: '10px' }}>
                                                <DeleteIcon />
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default Iata